<template>
  <div class="school-faculty">
    <h1>院系设置:</h1>
    <div class="box" v-for="list in facultyList" :key="list.id">
      <h3><span class="el-icon-office-building"></span>院系设置</h3>
      <p>{{list.arrangement}}</p>
      <h3><span class="el-icon-school"></span>重点实验室</h3>
      <p>{{list.laboratory}}</p>
      <h3><span class="el-icon-notebook-2"></span>重点学科</h3>
      <p>{{list.subject}}</p>
      <h3><span class="el-icon-collection"></span>可授予的学位</h3>
      <p>{{list.degree}}</p>
      <h3><span class="el-icon-user"></span>师资力量</h3>
      <p>{{list.teacherStaff}}</p>
      <h3><span class="el-icon-s-custom"></span>学生人数</h3>
      <p>{{list.studentNum}}</p>
    </div>
  </div>
</template>

<script>
import schoolFaculty from '../../api/configuration'
export default {
  data() {
    return {
      schoolName: '',
      facultyList: []
    }
  },
  created() {
    this.schoolName = this.$route.query.schoolName
    this.getSchoolFaculty(this.schoolName)
  },
  methods: {
    getSchoolFaculty() {
      schoolFaculty.getSchoolFaculty(this.schoolName).then(res => {
        this.facultyList = res.list
      })
    }
  },
}
</script>

<style scoped>
p {
  font-family: 微软雅黑;
  font-size: 16px;
  color: #666;
  margin-top: 10px;
  line-height: 2;
  text-indent: 2em;
  margin: 10px 0;
}
h3 {
  font-weight: 400;
  margin-top: 20px;
  font-size: 22px;
}
span {
  margin-right: 10px;
}
</style>